// src/lib/requestId.ts
import { toast } from 'sonner'
import { messagesNow } from '@/i18n'
import { messages } from '@/store/messages'

/** Заголовок ответа academy api: по нему в Graylog поднимается весь путь запроса. */
export const REQUEST_ID_HEADER = 'X-Request-Id'

/**
 * ID запроса из `baseQueryMeta` RTK Query. `null` — заголовка нет: 500 от внешнего слоя
 * сервера, `FETCH_ERROR`/`TIMEOUT_ERROR`, отмена (ответа не было вовсе).
 */
export const requestIdFromMeta = (meta: unknown): string | null => {
  const response = (meta as { response?: unknown } | null | undefined)?.response
  if (!(response instanceof Response)) return null
  return response.headers.get(REQUEST_ID_HEADER) || null
}

/** Копирует ID в буфер. `false` — нет Clipboard API или браузер отказал; исключений нет. */
export const copyRequestId = async (id: string): Promise<boolean> => {
  const clipboard = navigator.clipboard as Clipboard | undefined
  if (!clipboard) return false
  try {
    await clipboard.writeText(id)
    return true
  } catch {
    return false
  }
}

const REQUEST_ID_TOAST_DURATION_MS = 8000

/**
 * Тост ошибки с ID запроса и кнопкой «Скопировать». Тост живёт под детерминированным id,
 * поэтому отказ копирования перерисовывает ЭТОТ ЖЕ тост (ID остаётся виден, ниже — текст
 * отказа), а не вытесняет его новым. Sonner закрывает тост после action, если у события не
 * стоит `defaultPrevented`, — отменяем синхронно, закрываем сами только при успехе.
 */
export const showRequestIdToast = (message: string, id: string, copyFailed = false): void => {
  const m = messagesNow(messages)
  const toastId = `request-id:${id}`
  const idLine = m.requestId(id)
  toast.error(message, {
    id: toastId,
    duration: REQUEST_ID_TOAST_DURATION_MS,
    description: copyFailed ? `${idLine} · ${m.requestIdCopyFailed}` : idLine,
    action: {
      label: m.requestIdCopy,
      onClick: (event) => {
        event.preventDefault()
        void copyRequestId(id).then((ok) => {
          if (!ok) return showRequestIdToast(message, id, true)
          toast.dismiss(toastId)
          toast.success(messagesNow(messages).requestIdCopied)
        })
      },
    },
  })
}
